import { ReactUnityEventParameter } from 'react-unity-webgl/distribution/types/react-unity-event-parameters';
import React, { useCallback, useContext, useEffect } from 'react';
import { UnityMessageOutgoingEvent } from 'app/common/eventbus/Events';
import { NMUI4DContext } from 'app/common/context/NMUI4DContext';

type TProps = {
    isLoaded: boolean;
    sendMessage: (gameObjectName: string, methodName: string, parameter?: ReactUnityEventParameter) => void;
};

export const UnityCanvasSendMessageRequestForwarder = ({ isLoaded, sendMessage }: TProps) => {
    const apiGameObjectName = 'BrowserSendMessageContentViewerAPIController';
    const apiGameObjectMethod = 'SendRequest';

    const onForwardRequest = useCallback(
        (request: string) => {
            console.log('Sending request to Unity application API (UnityCanvas)', request);

            sendMessage(apiGameObjectName, apiGameObjectMethod, request);
        },
        [sendMessage],
    );

    const context = useContext(NMUI4DContext);

    useEffect(() => {
        if (!isLoaded) {
            return;
        }

        const eventCallback = (event: UnityMessageOutgoingEvent) => {
            onForwardRequest(event.request);
        };

        context.eventBus.register(UnityMessageOutgoingEvent.NAME, eventCallback);

        return () => {
            context.eventBus.unregister(UnityMessageOutgoingEvent.NAME, eventCallback);
        };
    }, [onForwardRequest, isLoaded]);

    return <></>;
};
